var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-mt-2",attrs:{"theme":"danger"}},[_vm._v(" "+_vm._s(_vm.exceedsRemainingEmploymentAllowanceText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }